export default __webpack_public_path__ + "static/media/logoPeagle.129d01cb.svg";